export interface User { // this should reflect the Cognito fields in the id_token properly
  uid: string;
  access_token: string;
  id_token: string;
  refresh_token: string;
  email: string;
  exp: number;
  picture?: string; // Profile picture URL from Google OAuth2
}

export interface Bookmark{
  title: string;
  url: string;
  addedOn: Date;
  summary: string;
  fid?: string;
  favicon?: string;
  tags?: string[];
}

export interface BulkTagUpdateRequest {
  bookmarkIds: string[];
  addTags?: string[];
  removeTags?: string[];
}

export enum QueueEntryStates {
  SAVING = 'saving',
  SAVED = 'saved',
  FAILED = 'failed',
  PENDING = 'pending',
  ALREADY_SAVED = 'already_saved'
}

export type QueueEntryState = QueueEntryStates.SAVING | QueueEntryStates.SAVED | QueueEntryStates.FAILED | QueueEntryStates.PENDING | QueueEntryStates.ALREADY_SAVED;

export interface BookmarksQueueEntry {
  url: string;
  status: QueueEntryState;
  existingTitle?: string;
  failureMessage?: string;
}
